var _linearGradient, _path, _g, _g2, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Structuralengineer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_n8000Bonn5Kf_mPINtvda",
    x1: 24,
    x2: 24,
    y1: 8.277,
    y2: 40.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_n8000Bonn5Kf_mPINtvda)",
    d: "M38,20v7h-7V12h-2v6H19v-6h-2v15h-7v-7H8v20c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2V20 H38z M19,20h10v7H19V20z M29,29v11H19V29H29z M10,29h7v11h-7V29z M38,40h-7V29h7V40z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29,14.126 31,15.874 31,12 29,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38,21.991 40,23.739 40,20 38,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,21.99 10,20 8,20 8,23.737"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17,15.873 19,14.125 19,12 17,12"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29,13.462 31,15.209 31,12 29,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38,21.326 40,23.074 40,20 38,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17,15.209 19,13.461 19,12 17,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,21.326 10,20 8,20 8,23.073"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_n8000Bonn5Kf_mPINtvdb",
    x1: 24,
    x2: 24,
    y1: -1622.684,
    y2: -1644.696,
    gradientTransform: "matrix(1 0 0 -1 0 -1620)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d43a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9360c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_n8000Bonn5Kf_mPINtvdb)",
    d: "M44.495,20.507L25.326,3.503C24.948,3.168,24.474,3,24,3s-0.948,0.168-1.326,0.503 L3.505,20.507c-0.42,0.374-0.449,1.02-0.064,1.43l1.636,1.745c0.369,0.394,0.984,0.424,1.39,0.067L24,8.428L41.533,23.75 c0.405,0.356,1.021,0.327,1.39-0.067l1.636-1.745C44.944,21.527,44.915,20.881,44.495,20.507z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Structuralengineer);
export default __webpack_public_path__ + "static/media/icons8-structuralengineer.0e756753ac755f7f700f3b7908b82fbc.svg";
export { ForwardRef as ReactComponent };